import React, { useState } from "react";
import api from "../api/axios";

const TrackService = () => {
  const [trackId, setTrackId] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const handleTrack = async () => {
    setError("");
    setData(null);

    try {
      const res = await api.get(
        `companyblog/track-service/${trackId}/`
      );
      setData(res.data);
    } catch (err) {
      setError("Invalid Track ID. Please try again.");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <label style={styles.label}>Track ID*</label>
        <input
          style={styles.input}
          placeholder="Enter Your TRACK ID"
          value={trackId}
          onChange={(e) => setTrackId(e.target.value)}
        />
        <button style={styles.button} onClick={handleTrack}>
          ENTER
        </button>
      </div>

      {/* Result */}
      {error && <p style={styles.error}>{error}</p>}

      {data && (
        
        <div style={styles.card}>
          <h1 style={{fontSize: "20px", fontWeight: "800"}}>Namaste {data.customer_name} Jiii !!</h1><br />
          <span style={{fontSize: "14px", fontWeight: "800"}}>Your Current Information</span>
          <Row label="Track ID" value={data.track_id} />
          <Row label="Customer Name" value={data.customer_name} />
          <Row label="Contact No" value={data.customer_contact} />
          <Row label="Problem" value={data.problems} />
          <Row label="Service Status" value={data.status} />
        </div>
      )}
    </div>
  );
};

const Row = ({ label, value }) => (
  <div style={styles.row}>
    <span style={styles.rowLabel}>{label}</span>
    <span>{value}</span>
  </div>
);

const styles = {
  page: {
    minHeight: "100vh",
    background: "#0f172a",
    paddingTop: "100px",
    color: "#fff",
    textAlign: "center",
  },
  header: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "30px",
  },
  label: {
    fontWeight: "600",
  },
  input: {
    padding: "8px",
    width: "220px",
  },
  button: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "8px 16px",
    cursor: "pointer",
  },
  card: {
    background: "#fff",
    color: "#000",
    width: "400px",
    margin: "0 auto",
    padding: "20px",
    borderRadius: "6px",
    textAlign: "left",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  rowLabel: {
    fontWeight: "600",
  },
  error: {
    color: "#f87171",
  },
};

export default TrackService;
